import { useEffect } from "react";

const SITE = "https://backyardbuddy.app";
const DEFAULTS = {
  title: "Backyard Buddy — Free Yard Planner App & AI Backyard Designs",
  description: "Free yard planner app: snap a photo of your yard, get an AI backyard design in minutes, then find plants and materials near you. Built on 38 years of landscape expertise from Linda.",
  image: `${SITE}/icon-512.png`,
};

// Updates the static tags shipped in public/index.html in place — exactly one <title>, one description,
// one canonical, one set of OG tags per page. (react-helmet-async on React 19 renders duplicates instead.)
function upsert(tag, matchKey, matchValue, attrs) {
  let el = document.head.querySelector(`${tag}[${matchKey}="${matchValue}"]`);
  if (!el) {
    el = document.createElement(tag);
    el.setAttribute(matchKey, matchValue);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

function apply({ title, description, url, image, jsonLd }) {
  document.title = title;
  upsert("meta", "name", "description", { content: description });
  upsert("meta", "property", "og:title", { content: title });
  upsert("meta", "property", "og:description", { content: description });
  upsert("meta", "property", "og:type", { content: "website" });
  upsert("meta", "property", "og:image", { content: image });
  upsert("meta", "name", "twitter:card", { content: "summary_large_image" });
  if (url) {
    upsert("link", "rel", "canonical", { href: url });
    upsert("meta", "property", "og:url", { content: url });
  } else {
    document.head.querySelector('link[rel="canonical"]')?.remove();
    document.head.querySelector('meta[property="og:url"]')?.remove();
  }
  const existing = document.getElementById("bb-jsonld");
  if (jsonLd) {
    const script = existing || document.head.appendChild(Object.assign(document.createElement("script"), { id: "bb-jsonld", type: "application/ld+json" }));
    script.textContent = JSON.stringify(jsonLd);
  } else {
    existing?.remove();
  }
}

export default function Seo({ title, description, path = "/", image, jsonLd }) {
  const url = `${SITE}${path}`;
  const img = image || DEFAULTS.image;
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    apply({ title, description, url, image: img, jsonLd: ld ? JSON.parse(ld) : null });
    return () => apply({ ...DEFAULTS, url: null, jsonLd: null });
  }, [title, description, url, img, ld]);
  return null;
}
